import { useMutation } from '@tanstack/react-query'

import {
  postBrokersUnprocessedEnrollmentsIdGenerateVban,
} from 'utils/web_api'
import { type BrokersEnrollmentEnriched } from 'utils/web_api.schemas'

import { type GrapeAPIErrorType } from './GrapeAPIError'

export function useGenerateVban ({
  enrollmentId,
}: {
  enrollmentId: string
}) {
  const orvalMutation = useMutation<
    BrokersEnrollmentEnriched,
    GrapeAPIErrorType,
    void
  >({
    mutationFn: async () => {
      return await postBrokersUnprocessedEnrollmentsIdGenerateVban(
        enrollmentId
      )
    },
    mutationKey: ['generate-vban', enrollmentId],
  })

  return {
    ...orvalMutation,
    mutate: (_variables?: void, options?: Parameters<typeof orvalMutation.mutate>[1]) => {
      orvalMutation.mutate(undefined, options)
    },
  }
}
